<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog 
            v-model="dialog" 
            color="#323A46"
            persistent
            :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
            content-class="border-radius-2 pt-0"
            overlay-color="#7764CA"
            overlay-opacity="1">
            <div class="onboarding-logo-wrapper">
                <v-img 
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-row class="progress-bar-wrapper ma-0">
                <v-col cols="12" class="position-relative">
                    <v-progress-linear
                    background-color="#514585"
                    color="#C4BBE7"
                    v-model="completedTasksPercentage"
                    height="18"
                    class="pointer-events-none border-progress-bar"
                    rounded
                    >
                    <strong>Paso {{ currentPage }} de {{ totalPages - 1 }}</strong>
                </v-progress-linear>
                <v-img
                :src="require('@/assets/img/icons/check-stroke.png')"
                height="48"
                width="48"
                class="check-icon"
                ></v-img>
            </v-col>
    </v-row>
        
        <v-container>
            <v-card class="custom-card border-radius-2 pa-4 pa-sm-8 mt-12 avatar-card-wrapper">
                <v-card-title class=" d-flex justify-center px-4 py-1 position-relative">
                    <v-row>
                        <v-col cols="auto" class="">
                            <v-img
                                :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                                max-height="40px"
                                max-width="40px"
                                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                                contain
                                class="main-sound-img cursor-pointer"
                                @click="read"
                            ></v-img>
                        </v-col>
                        <v-col cols="auto" class="flex-fill pl-0">
                            <p
                                class="main-title d-flex justify-center mb-0"
                                v-html="$t('initialTour.avatar_select')"
                                >
                            </p>
                        </v-col>
                    </v-row>
                </v-card-title>
                    <v-container fluid class="scroll-section">
                            <div class="cards-wrapper">
                                <v-row
                                    class="cards__container pa-0"
                                    id="cards-swiped"
                                >
                                    <v-col
                                        data-cy="choose-avatar"
                                        cols="4"
                                        sm="2"
                                        class="box position-relative"
                                        v-for="(avatar, index) of defaultAvatarPack.avatarDTOList"
                                        :key="index"
                                        @click="setActiveAvatar(index)"
                                    >
                                        <Avatar :avatar="avatar" ref="avatars[index]"></Avatar>
                                        <em class="mdi mdi-checkbox-marked-circle check-avatar transition-all pt-2"></em>
                                    </v-col>
                                </v-row>
                            </div>
                    </v-container>
                    <v-card-actions class="d-flex justify-center card-actions">
                        <v-btn
                        data-cy="continue-button-avatar-select"
                        class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                        large
                        dark
                        @click="nextPass">{{
                            $t('initialTour.continue')
                        }}</v-btn>
                    </v-card-actions>
                </v-card>
        </v-container>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable no-plusplus */

import { mapState, mapActions } from 'vuex'
import Avatar from './AvatarCore/Avatar.vue'

export default {
    components: {
        Avatar,
    },
    props: {
        dialog: { type: Boolean, default: false },
    },
    data: () => ({
        currentPage: 2,
        totalPages: 4,
        logo: require('@/assets/img/brand/logo.svg'),
    }),
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            defaultAvatarPack: (state) => state.dashboard.defaultAvatarPack,
        }),
        completedTasksPercentage() {
            if (this.currentPage && this.totalPages) {
                return Math.round((this.currentPage / this.totalPages) * 100);
            } else {
                return 0;
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.initBoxes()
        }, 0)
    },
    methods: {
        ...mapActions('dashboard', ['showCategories', 'showAvatars']),
        ...mapActions('userData', ['changeAvatar']),
        initBoxes() {
            const boxes = document.querySelectorAll('.box')

            const firstAvatar = boxes[0].childNodes[0].childNodes[0]
            const parentElement = firstAvatar.parentElement.parentElement;
            const emElement = parentElement.querySelector('.check-avatar');

            firstAvatar.classList.add('avatar-active')
            emElement.classList.add('check-active')
        },
        shiftLeft() {
            const boxes = document.querySelectorAll('.box')
            const tmpNode = boxes[0]
            boxes[0].className = 'box move-out-from-left'

            setTimeout(() => {
                document.querySelector('.avatar-active').classList.toggle('avatar-active')
                if (boxes.length > 5) {
                    tmpNode.classList.add('box--hide')
                    boxes[5].className = 'box move-to-position5-from-left'
                }
                boxes[1].className = 'box move-to-position1-from-left'
                boxes[2].className = 'box move-to-position2-from-left'
                boxes[3].className = 'box move-to-position3-from-left'

                boxes[3].childNodes[0].childNodes[0].className += ' avatar-active'
                document
                    .querySelector('.avatar-active')
                    .querySelector('img')
                    .setAttribute(
                        'src',
                        document.querySelector('.avatar-active').querySelector('img').src
                    )

                boxes[4].className = 'box move-to-position4-from-left'
                boxes[0].remove()

                document.querySelector('.cards__container').appendChild(tmpNode)
            }, 200)
        },
        shiftRight() {
            document.querySelector('.avatar-active').classList.toggle('avatar-active')
            const boxes = document.querySelectorAll('.box')
            boxes[4].className = 'box move-out-from-right'
            setTimeout(() => {
                const noOfCards = boxes.length
                if (noOfCards > 4) {
                    boxes[4].className = 'box box--hide'
                }

                const tmpNode = boxes[noOfCards - 1]
                tmpNode.classList.remove('box--hide')
                boxes[noOfCards - 1].remove()
                const parentObj = document.querySelector('.cards__container')
                parentObj.insertBefore(tmpNode, parentObj.firstChild)
                tmpNode.className = 'box move-to-position1-from-right'
                boxes[0].className = 'box move-to-position2-from-right'
                boxes[1].className = 'box move-to-position3-from-right'

                boxes[1].childNodes[0].childNodes[0].className += ' avatar-active'
                document
                    .querySelector('.avatar-active')
                    .querySelector('img')
                    .setAttribute(
                        'src',
                        document.querySelector('.avatar-active').querySelector('img').src
                    )

                boxes[2].className = 'box move-to-position4-from-right'
                boxes[3].className = 'box move-to-position5-from-right'
            }, 200)
        },
        nextPass() {
            const avatarSelect = document.querySelector('.avatar-active').getAttribute('id')
            const found = this.defaultAvatarPack.avatarDTOList.find(
                (el) => Number(el.id) === Number(avatarSelect)
            )
            if (!found) {
                this.$modal.show({ text: 'Debes seleccionar un avatar para continuar' })
                // alert('Debes seleccionar un avatar para continuar')
                return
            }
            this.changeAvatar(found)
            this.showAvatars()
            this.showCategories()
        },
        setActiveAvatar(index) {
            const boxes = document.querySelectorAll('.box')
            const activeAvatar = boxes[index].childNodes[0].childNodes[0]
            const parentElement = activeAvatar.parentElement.parentElement;
            const emElement = parentElement.querySelector('.mdi-checkbox-marked-circle');
            
            document.querySelector('.avatar-active').classList.remove('avatar-active')
            document.querySelector('.check-active').classList.remove('check-active')
            activeAvatar.className += ' avatar-active'
            emElement.className += ' check-active'
            
        },
        read(){
            this.play('avatar_select')
        },
        play(text) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}onboarding/${text}.mp3`);
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
    },
}
</script>
<style lang="scss">
.main-title{
    font-size: 1.5em;
    word-break: keep-all;
    // padding-left: 20px;
    // top: 8px;
    position: relative;
}
.titles{
    font-size: 1rem;
    line-height: 1.4rem;
    color: #323A46;
    text-align: center;
    span{
        color: #7764CA;
    }
}
.icon-rotate {
    transform: rotate(180deg);
}

.cont {
    display: flex;
    justify-content: center;
    align-items: center;
}

.but {
    /* margin-left: 0 3%; */
    width: 2rem;
    cursor: pointer;
    z-index: 30;
}

.but--inactive {
    opacity: 0.2;
}

.but img {
    width: 60%;
}

.cards-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: transparent;
}

.cards__container {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0;
    width: 100%;
}

.scroll-section{
    // min-height: 20rem;
    max-height: 40vh;
    overflow-y: auto;
    overflow-x: hidden;
    @media screen and (max-height: 600px) {
        max-height: 35vh;
    }
}
.card-actions{
    min-height: 60px;
}

.box .avatar-box img{
    background-color: white;
    border-radius: 100%;
}

.v-dialog{
    .avatar-card-wrapper {
        padding: 10px !important;
        margin-top: 80px !important;
        @media screen and (max-width: 767px) {
            margin-top: 80px !important
        }
    }
}

.card__title {
    padding: 1rem;
}

.box--hide {
    display: none !important;
}
.avatar-img{
    background-color: #FFF;
    border-radius: 500px;
    z-index: 1;
}
.avatar-active {
    &::after{
        content: '';
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%),
        linear-gradient(0deg, rgba(174, 236, 180, 0.3), rgba(174, 236, 180, 0.3));
        border-radius: 500px;
        display: block;
        height: 112%;
        position: absolute;
        left: -6%;
        top: -6%;
        width: 112%;
        z-index: 0;
    }
}
.check-avatar{
    display: none;
}
.check-active{
    color: #6857B2;
    display: block;
    font-size: 32px;
    position: absolute;
    right: 2px;
    bottom: 2px;
    z-index: 2;
    &::after{
        content: '';
        background: white;
        border-radius: 50%;
        display: block;
        height: 36px;
        position: absolute;
        left: 50%;
        top: calc(50% + 3px);
        transform: translate(-50%, -50%);
        width: 36px;
        z-index: -1;
    }
    @media screen and (max-width: 940px) {
        font-size: 24px;
        &::after{
            content: '';
            height: 26px;
            top: calc(50% + 4px);
            width: 26px;
        }
    }
}
</style>
